export default "__VITE_ASSET__BCFP62EO__"